export default defineComponent({
  name: 'ItemTabDosage',
  props: {
    items: Array
  }
});